'use strict';

angular.module('TurneroApp').component('coCentrosAtencion', {
    bindings: {
        ctrlAdmin: '='
    },
    controller: [
        'centrosAtencionService',
        'utilsService',
        'TurneroAppConstant',
        '$sessionStorage',
        '$element',
        function (centrosAtencionService, utilsService, TurneroAppConstant, $sessionStorage, $element) {
            var ctrl = this;

            ctrl.centroCrear = false;
            ctrl.centroModificar = false;
            ctrl.centroConsultar = true;
            ctrl.centroVer = false;
            ctrl.centros = {};
            ctrl.focusBuscar = false;
            ctrl.permisos = TurneroAppConstant.Permisos;

            //GENERAL
            ctrl.limitOptions = [10, 25, 50, 75, 100, {
                label: 'Todos',
                value: function () {
                    return ctrl.pagination.total;
                }
            }];

            ctrl.query = {
                limit: 10,
                page: 1,
                filter: ''
            };

            //Se inicializa en null para que al principio no tome que no hay valores
            ctrl.pagination = {
                total: null
            };

            ctrl.filter = false;

            ctrl.$onChanges = function () {
                ctrl.grillaReload();
            };

            ctrl.limpiarMemoria = function () {
                ctrl.centros = {};
                ctrl.centroCrear = false;
                ctrl.centroModificar = false;
                ctrl.centroConsultar = false;
                ctrl.centroVer = false;
            }

            ctrl.removeFilter = function () {
                ctrl.query.filter = '';
                ctrl.grillaReload();
                ctrl.filter = false;
            };

            ctrl.mostrarBuscar = function () {
                ctrl.filter = true;
                ctrl.focusBuscar = true;
            };

            ctrl.grillaReload = function () {
                ctrl.limpiarMemoria();
                ctrl.centroConsultar = true;

                if (ctrl.query.filter.length > 2 || ctrl.query.filter.length == 0) {
                    ctrl.getData(ctrl.query.page, ctrl.query.limit, 'grid', cargarDatos)
                }
            };

            ctrl.getData = function (page, limit, tipo, callback) {

                ctrl.promise = centrosAtencionService.getfiltro({
                    'filtro.nro_Pagina': page,
                    'filtro.tam_Pagina': limit,
                    'filtro.texto': ctrl.query.filter
                }).$promise.then(function (data) {
                    callback(tipo, data);
                }).catch(function (error) {
                    utilsService.errores(error)
                });

            }

            function cargarDatos(tipo, data) {
                if (tipo == 'grid') {
                    ctrl.centros = data.Data;
                    ctrl.pagination.total = data.Paging.Reg_Totales;
                } else if (tipo == 'xls') {
                    var arrayObject = data.Data;
                    ctrl.arrayExport = [];
                    ctrl.arrayExport[0] = ['Id', 'Nombre', 'Fecha Creación', 'Domicilio', 'Repartición/Razón Social'];
                    for (var i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 1] = [
                            arrayObject[i].Id_Centro_Atencion,
                            arrayObject[i].N_Centro_Atencion,
                            arrayObject[i].Fecha_Creacion ? moment(arrayObject[i].Fecha_Creacion).toDate().toLocaleString() : ' - ',
                            arrayObject[i].Domicilio ? arrayObject[i].Domicilio : ' - ',
                            arrayObject[i].Organismo ? arrayObject[i].Organismo : ' - ',
                        ]
                    }
                    swal.close();
                    ctrl.Excel.down([{
                        name: 'Centros de Atencion',
                        data: ctrl.arrayExport
                    }]);
                }
            }

            //ALTA
            ctrl.LoadAlta = function () {
                ctrl.limpiarMemoria();
                ctrl.centroCrear = true;
                ctrl.tLoadAlta();
            };

            //MODIFICAR
            ctrl.modificarCentro = function (item) {
                ctrl.limpiarMemoria();
                ctrl.centroModificar = true;
                ctrl.tLoadModificar(item);
            };

            //VER
            ctrl.verCentro = function (item) {
                ctrl.limpiarMemoria();
                ctrl.centroVer = true;
                ctrl.tLoadModificar(item);
            };

            //BAJA
            ctrl.eliminarCentro = function (item) {
                swal({
                    title: "Eliminar Centro de Atención",
                    text: "¿Desea eliminar el centro de atención?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#971b2f",
                    confirmButtonText: "Si, eliminarlo!",
                    cancelButtonText: "No, cancelar!",
                    allowEscapeKey: false,
                    allowOutsideClick: false
                }).then(function () {
                    centrosAtencionService.delete({ 'id': item.Id_Centro_Atencion }).$promise.then(function () {
                        ctrl.grillaReload();
                        swal("Eliminado!", "El centro de atención ha sido eliminado correctamente.", "success");
                        if (item.Id_Centro_Atencion == ctrl.ctrlAdmin.centroAtencionSeleccionado.id) {
                            ctrl.ctrlAdmin.centroAtencionSeleccionado = null;
                            $sessionStorage.clear();
                        }
                    }).catch(function (error) {
                        utilsService.errores(error);
                    });
                });
            };

            //EXPORTAR A EXCEL
            ctrl.isOpen = false;
            ctrl.selectedMode = 'md-fling';
            ctrl.selectedDirection = 'up';
            ctrl.exportar = function (tipo) {
                utilsService.swalTitle('Exportando datos', 'info')
                ctrl.arrayExport = [];
                ctrl.getData(1, ctrl.pagination.total, tipo, cargarDatos)

            }
            ctrl.Excel = {
                down: function () {
                },
            }

            $element.find('input').on('keydown', function (ev) {
                ctrl.searchTerm = ctrl.searchTerm
                ev.stopPropagation();
            });

        }
    ],
    template: require('./centrosAtencion.html')
});



// WEBPACK FOOTER //
// ./app/components/centrosAtencion/centrosAtencionComponent.js